import { useAuth } from '@/hooks';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useMailBox = () => {
  const { currUser } = useAuth();
  const { feOutlook } = useFlags();

  if (!feOutlook) {
    return {
      isMailBoxConnected: currUser?.connected_gmail,
      isOutlookEnabled: false,
      connectedMailboxValue: currUser?.connected_gmail ? 'gmail' : '',
    };
  }

  const connectedMailbox = currUser?.connected_mailbox || {};
  const connectedMailboxValue = Object?.keys(connectedMailbox).find(
    (key) => connectedMailbox?.[key] === true
  );
  const connectedCalendar = currUser?.connected_calendar || {};
  const canFetchMeetingRooms = currUser?.can_fetch_meeting_rooms;
  const connectedCalValue = Object?.keys(connectedCalendar).find(
    (key) => connectedCalendar?.[key] === true
  );

  return {
    isMailBoxConnected: connectedMailbox?.gmail || connectedMailbox?.outlook,
    isCalConnected: connectedCalendar?.gcal || connectedCalendar?.mscal,
    canFetchMeetingRooms: canFetchMeetingRooms,
    isOutlookEnabled: true,
    connectedMailboxValue: connectedMailboxValue,
    connectedCalValue,
  };
};
